<template>
  <div>
    <Spinner></Spinner>
  </div>
</template>
<script>
  import cryptoRedirectMixin from '@/common/mixins/cryptoRedirect';
  import {MENU_CRYPTO, SET_ACTIVE_TAB_ID} from "@/store/modules/header/type";

  export default {
    mixins: [cryptoRedirectMixin],
    async created() {
      this[SET_ACTIVE_TAB_ID](MENU_CRYPTO);
      this.redirectCryptoRegistration();
    }
  }
</script>
